import { LitElement, html } from "lit";

import { customElement, property, state } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

import { notificationItemStyles } from "./notification-item.css";
import type { NotificationSeverity } from "./notification-service";

import "../alert-item/alert-item";

@customElement("notification-item")
export class NotificationItem extends LitElement {
  static override styles = notificationItemStyles;

  @property({ type: String })
  message = "";

  @property({ type: String })
  severity: NotificationSeverity = "info";

  @property({ type: Number })
  duration = 5000;

  @property({ type: String })
  notificationId = "";

  @state()
  private isEntering = true;

  private timeoutId?: number;

  override connectedCallback() {
    super.connectedCallback();

    // Trigger entry animation
    requestAnimationFrame(() => {
      this.isEntering = false;
    });

    // Set auto-dismiss timer
    this.timeoutId = window.setTimeout(() => {
      this.dismiss();
    }, this.duration);
  }

  override disconnectedCallback() {
    super.disconnectedCallback();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  private dismiss() {
    // Dispatch remove event - parent will handle removal and CSS will animate
    this.dispatchEvent(
      new CustomEvent("notification-dismissed", {
        bubbles: true,
        detail: { notificationId: this.notificationId },
      }),
    );
  }

  protected override render() {
    return html`
      <div
        class=${classMap({
          "notification-wrapper": true,
          "notification-entering": this.isEntering,
        })}
        @click=${this.dismiss}
      >
        <alert-item message="${this.message}" severity="${this.severity}"></alert-item>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "notification-item": NotificationItem;
  }
}
